import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  deposite_type: "",
  status: "",
  searchTransactionId: "",
  searchSenderName: "",
  searchReceiverName: "",
  searchSCTransactionId: "",
  searchAmounts: "",
  searchConfirmationId: "",
  searchIPCountry: "",
  searchAccountNumber: "",
  sc_type: ""
};
export function HistoryFilter({ filterValues, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };

  const [historyFilter, setHistoryFilter] = useState(initialValues);

  return (
    <>
      <Formik
        initialValues={historyFilter}
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={(values) => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="deposite_type"
                  placeholder="Filter by Deposit Type"
                  onChange={(e) => {
                    setFieldValue("deposite_type", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.deposite_type}
                >
                  <option value="">All</option>
                  {/* <option value="1">eCheck</option> */}
                  <option value="2">ACH</option>
                  <option value="3">Credit Card</option>
                  {/* <option value="4">Wire Transfer</option> */}
                  {/* <option value="5">General</option> */}
                  <option value="6">Debit Card</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Deposit Type</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by status Type"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1">Pending</option>
                  <option value="2">Rejected</option>
                  <option value="3">Accepted</option>
                  <option value="4">Approved</option>
                  <option value="5">Cancelled</option>
                  <option value="6">Declined</option>
                  <option value="7">Failed</option>
                  <option value="8">Awaiting Processing</option>
                  <option value="9">Being Processed</option>
                  <option value="10">Hold</option>
                  <option value="11">Returned / Refunded</option>
                  <option value="12">Returned Ineligible</option>
                  <option value="13">Refund Processing</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="sc_type"
                  placeholder="Filter by SC Type"
                  onChange={(e) => {
                    setFieldValue("sc_type", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.sc_type}
                >
                  <option value="">All</option>
                  <option value="Due Dilligence">Due Dilligence</option>
                  <option value="Earnest Money">Earnest Money</option>
                  <option value="Other">Other</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>SC Type</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchTransactionId"
                  placeholder="Transaction id"
                  onBlur={handleBlur}
                  value={values.searchTransactionId}
                  onChange={(e) => {
                    setFieldValue("searchTransactionId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Transaction ID</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchSenderName"
                  placeholder="Sender Name"
                  onBlur={handleBlur}
                  value={values.searchSenderName}
                  onChange={(e) => {
                    setFieldValue("searchSenderName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchReceiverName"
                  placeholder="Receiver Name"
                  onBlur={handleBlur}
                  value={values.searchReceiverName}
                  onChange={(e) => {
                    setFieldValue("searchReceiverName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchAmounts"
                  placeholder="Amounts"
                  onBlur={handleBlur}
                  value={values.searchAmounts}
                  onChange={(e) => {
                    let value = e.target.value.replace(/-/g, "");
                    const regExp = new RegExp(/^\d*\.?\d*$/);
                    if (regExp.test(value)) {
                      setFieldValue("searchAmounts", value);
                      handleSubmit();
                    } else {
                      setFieldValue("searchAmounts", 0);
                    }
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Amounts</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchConfirmationId"
                  placeholder="Confirmation Id"
                  onBlur={handleBlur}
                  value={values.searchConfirmationId}
                  onChange={(e) => {
                    setFieldValue("searchConfirmationId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Confirmation ID</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchSCTransactionId"
                  placeholder="SC-Transaction Id"
                  onBlur={handleBlur}
                  value={values.searchSCTransactionId}
                  onChange={(e) => {
                    setFieldValue("searchSCTransactionId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>SC-Transaction ID</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchIPCountry"
                  placeholder="IP"
                  onBlur={handleBlur}
                  value={values.searchIPCountry}
                  onChange={(e) => {
                    setFieldValue("searchIPCountry", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>IP</b>
                </small>
              </div>

              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchAccountNumber"
                  placeholder="A/C No."
                  onBlur={handleBlur}
                  value={values.searchAccountNumber}
                  onChange={(e) => {
                    setFieldValue("searchAccountNumber", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>A/C No.</b>
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
